import { configure } from 'mobx';
import StudyEvaluationStore from './StudyEvaluationStore';
import AuthenticationStore from './AuthenticationStore';
import AttendanceStore from './AttendanceStore';
import CommonStore from './CommonStore';
import { createContext } from 'react';
import ObeStore from './ObeStore';
import NotEnrolledStore from './NotEnrolledStore';
import DocumentStore from './DocumentStore';

configure({enforceActions: 'always'});

export class RootStore {
    studyEvaluationStore: StudyEvaluationStore;
    commonStore:CommonStore;
    authenticationStore:AuthenticationStore;
    attendanceStore:AttendanceStore;
    obeStore:ObeStore;
    notEnrolledStore:NotEnrolledStore;
    document:DocumentStore;
    
    constructor() {
        this.studyEvaluationStore = new StudyEvaluationStore(this);
        this.commonStore = new CommonStore(this);
        this.authenticationStore = new AuthenticationStore(this);
        this.attendanceStore = new AttendanceStore(this);
        this.obeStore = new ObeStore(this);
        this.notEnrolledStore = new NotEnrolledStore(this);
        this.document = new DocumentStore(this);
    }
}

export const RootStoreContext = createContext(new RootStore());